import { useState } from 'react';

interface FAQ {
  id: string;
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="flex flex-col gap-3">
      {faqs.map((faq) => {
        const isOpen = openId === faq.id;
        return (
          <div
            key={faq.id}
            className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-200"
          >
            <button
              onClick={() => toggleFAQ(faq.id)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
            >
              <span className={`text-sm md:text-base font-medium pr-4 ${isOpen ? 'text-primary-700' : 'text-foreground-800'}`}>
                {faq.question}
              </span>
              <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
                <i className={`text-lg ${isOpen ? 'text-primary-500 ri-arrow-up-s-line' : 'text-foreground-400 ri-arrow-down-s-line'}`}></i>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-4">
                <div className="pt-1 border-t border-background-200/70">
                  <p className="text-sm text-foreground-600 leading-relaxed pt-3">
                    {faq.answer}
                  </p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}